import * as r from 'easit--routing';
import * as moment from 'moment';
import { IDateTimeService } from 'eTip--common';
// import { addDateSetTo6HoursMorning, addDate, isTheSameDay } from 'easit--utils';
import { FilterType, RateFilterMinOddsRateInInput, RateFilterMaxOddsRateInInput } from './models/mainCategoryMenu';
import { areDatesEqual, addDate, addDateSetTo6HoursMorning, isTheSameDay, getNextWeekendStartTime, getNextWeekendEndTime } from 'easit--utils';
import { EBetGames } from '../eTipCommon/api/ebetGames';
export * from 'easit--routing';
import { translation } from 'easit--localization';
import { EventLiveInPrematchListLivePrefixForUrl } from './models/eventListModel';

moment.locale('sk');

export const paths = () => {
    return {
        home: `/${translation().route_PrematchHome}`,
        eventsList: `/${translation().route_StandardEvents}/:categoryId?/:eventId?/:detailId?`,
        eventDetail: `/${translation().route_StandardEventDetail}/:eventId?`,
        liveEventDetail: `/${translation().route_LiveEventDetail}/:eventId?`,
        //betDetail: `/${translation().route_BetDetail}/:betId`,
        //betDetailPublic: `/${translation().route_BetDetailPublic}/:publicBetId`,
        //weekHit: `/zasah-smoliar/:type`,
        favorites: '/moje',
        getTicketDetailPublic(publicTicketId: string) {
            return '/tiket/' + publicTicketId;
        },
        ticketList: `/${translation().route_BetList}`,
        ticketDetail: `/${translation().route_TicketDetail}/:ticketId?`,
        ticketWinList: `/${translation().route_BetWinList}`,
        legacyTicketDetailForTipos: `/moj-tiketl/:ticketId?`,
        getLegacyTicketDetailForTipos: (ticketId: string, validBackUrl: string) => {
            let base = `/moj-tiketl/${ticketId}`;
            if (validBackUrl) {
                base += "?urlref=" + window.encodeURIComponent(validBackUrl);
            }
            return base;
        },
        ticketListVG: `/${translation().route_BetListVG}`,
        ticketDetailVG: `/${translation().route_TicketDetailVG}/:ticketId?`,
        ticketDetailPublic: `/${translation().route_BetDetailPublic}/:publicTicketId?`,
        legacyTicketDetailPublic: `/${translation().route_LegacyTicketDetailPublic}/:publicTicketId?`,
        getLegacyTicketDetailPublic(publicTicketId: string) {
            return `/${translation().route_LegacyTicketDetailPublic}/${publicTicketId}`;
        },
        ticketDetailByNumber: `/${translation().route_TicketDetailByNumber}/:ticketNumber?`
    };
}

export interface IPushToEventDetailParams extends IOptionalMainMenuParams {
    eventKey: string;
    ignoreHistory?: boolean;
}

export const pushToEventDetail = (params: IPushToEventDetailParams) => {
    let path = paths().eventDetail.replace(':eventId?', `${params.eventKey}`);
    r.push(enrichPathOfOptionalMainMenuParams(path, params), params.ignoreHistory);
};

const eventKey2IdRegExp = /^([0-9]+)[^0-9]+.*$/;
export const redirectToLiveEventDetailFromPrematch = (params: IPushToEventDetailParams, withOpenLiveStream?: boolean) => {
    let eventId: string;

    let match = eventKey2IdRegExp.exec(params.eventKey);
    if (match && match.length) {
        eventId = match[1];
    } else {
        eventId = params.eventKey;
    }
    let path = paths().liveEventDetail.replace(':eventId?', `${eventId}`);
    if (withOpenLiveStream) {
        path += "?ls=1";
    }
    document.location.href = path;  // no hash, base link is same as link with hash
};

export const pushToTicketDetail = (ticketId: string) => {
    let path = paths().ticketDetail.replace(':ticketId?', `${ticketId}`);
    r.push(path);
};

export const pushToTicketDetailForVG = (ticketId: string) => {
    let path = paths().ticketDetailVG.replace(':ticketId?', `${ticketId}`);
    r.push(path);
};

export const pushToTicketDetailByNumber = (ticketNumber: string) => {
    if (ticketNumber) {
        ticketNumber.trim();
    }
    let path = paths().ticketDetailByNumber.replace(':ticketNumber?', `${ticketNumber}`);
    r.push(path);
};

const enrichPathOfOptionalMainMenuParams = (path: string, params: IOptionalMainMenuParams): string => {
    if (params.filter) path = addParams(path, 'filter=' + params.filter);
    if (params.filter === FilterType.timeDateFilter) { path = addParams(path, 'timeDate=' + params.filterParams.timeDateFilterValue); }
    if (isTimeFilterParams(params.filterParams) && params.filterParams.hours) path = addParams(path, 'hours=' + params.filterParams.hours);
    if (isDateFilterParams(params.filterParams) && params.filterParams.date) path = addParams(path, 'date=' + moment(params.filterParams.date).toISOString());
    if (params.searchBy) path = addParams(path, 'searchBy=' + params.searchBy);
    if (params.gameId || params.gameId === EBetGames.Standard1X2) path = addParams(path, 'gameId=' + params.gameId);
    if (params.gameGroup) path = addParams(path, 'gameGroup=' + params.gameGroup);
    if (params.categoryKey) path = addParams(path, 'categoryId=' + params.categoryKey);
    if (params.favorites) path = addParams(path, 'favorites=' + params.favorites);
    if (params.rateFrom && params.rateFrom != 1) { // ignore zero
        path = addParams(path, 'rateFrom=' + params.rateFrom);
    }
    if (params.rateTo) { // ignore zero
        path = addParams(path, 'rateTo=' + params.rateTo);
    }
    return path;
};

export function createEventDetailParams(
    params: {
        eventId: string;
    },
    query?: {
        categoryId?: string;
        gameGroup?: string;
        from?: string;
        to?: string;
        searchBy?: string;
        filter?: string;
        hours?: string;
        date?: string;
    }
) {
    const result: IPushToEventDetailParams = {
        eventKey: params.eventId
    };

    if (query) {
        result.gameGroup = query.gameGroup ? Number(query.gameGroup) : undefined;
        parseOptionalMainMenuParams(result, query);
    }
    return result;
}

function parseOptionalMainMenuParams(
    result: IOptionalMainMenuParams,
    query: {
        categoryId?: string;
        searchBy?: string;
        filter?: string;
        hours?: string;
        date?: string;
        timeDate?: string;
        rateFrom?: string;
        rateTo?: string;
    }
) {
    result.searchBy = query.searchBy;
    result.filter = query.filter ? Number(query.filter) : undefined;
    if (!!query.categoryId) result.categoryKey = query.categoryId;
    if (result.filter === FilterType.byTime) result.filterParams = { hours: query.hours && Number(query.hours) };
    if (isByDateFilter(result.filter)) result.filterParams = { date: query.date && new Date(query.date) };
    if (result.filter === FilterType.timeDateFilter) result.filterParams = { timeDateFilterValue: query.timeDate as TimeDateFilterOptions };
    if (!!query.rateFrom) {
        result.rateFrom = Number(query.rateFrom);
    }
    if (!!query.rateTo) {
        result.rateTo = Number(query.rateTo);
    }
}

export interface IPushToEventListParams extends IOptionalMainMenuParams { }

export interface IParsedEventListParams extends IPushToEventListParams {
    isLive: boolean;
}

export interface IFilterParams extends ITimeFilterParams, IDateFilterParams {
    timeDateFilterValue?: TimeDateFilterOptions;
}

export interface ITimeFilterParams {
    hours?: number;
}

export interface IDateFilterParams {
    date?: Date;
}

export enum TimeDateFilterOptions { Plus1 = 'Plus1', Plus3 = 'Plus3', Plus6 = 'Plus6', Today = 'Today', TodayTomorrow = 'TodayTomorrow', Weekend = 'Weekend', Tomorrow = 'Tomorrow', Plus7d = 'Plus7' };

export interface IOptionalMainMenuParams {
    categoryKey?: string;
    eventKey?: string;
    detailId?: number;
    gameId?: string;
    gameGroup?: number;
    filter?: number;
    filterParams?: IFilterParams;
    searchBy?: string;
    favorites?: number;
    rateFrom?: number;
    rateTo?: number;
}

export function createEventListParams(
    params: {
        categoryId?: string;
        eventId?: string;
        detailId?: string;
    },
    query?: {
        categoryId?: string;
        gameId?: string;
        gameGroup?: string;
        from?: string;
        to?: string;
        searchBy?: string;
        filter?: string;
        hours?: string;
        date?: string;
        favorites?: number;
        rateFrom?: string;
        rateTo?: string;
    },
    defaults?: {
        categoryKey?: string;
        eventKey?: string;
        isLive?: boolean;
        detailId?: number;
        gameId?: string;
        favorites?: number;
    }
): IParsedEventListParams {

    let eventIdFromParam: string | null;
    let isLiveFromParam: boolean | null;

    if (params.eventId) {
        if (params.eventId.startsWith(EventLiveInPrematchListLivePrefixForUrl)) {
            eventIdFromParam = params.eventId.substring(1);
            isLiveFromParam = true;
        } else {
            eventIdFromParam = params.eventId;
            isLiveFromParam = false;
        }
    }

    const result: IParsedEventListParams = {
        categoryKey: params.categoryId ? params.categoryId : defaults && defaults.categoryKey,
        eventKey: eventIdFromParam ? eventIdFromParam : defaults && defaults.eventKey,
        isLive: isLiveFromParam === undefined ? defaults && defaults.isLive : isLiveFromParam,
        detailId: params.detailId ? Number(params.detailId) : defaults && defaults.detailId
    };
    if (query) {
        result.gameId = query.gameId ? query.gameId : defaults && defaults.gameId;
        result.gameGroup = query.gameGroup ? Number(query.gameGroup) : undefined;
        result.favorites = query.favorites ? Number(query.favorites) : defaults.favorites;
        parseOptionalMainMenuParams(result, query);
    }
    return result;
}

export const prepareFromTo = (params: IPushToEventListParams, dateTimeService: IDateTimeService): { from?: Date; to?: Date, canUseLiveInPrematch: boolean } => {
    // canUseLiveInPrematch - same in desktop routing/prepareFromTo and mobile dateFilter/fromToFilter

    if (params.filter == FilterType.today) {
        let now = dateTimeService.now();
        return {
            from: now,
            to: addDateSetTo6HoursMorning(now, 'day', 1),
            canUseLiveInPrematch: true
        };
    }
    if (params.filter == FilterType.tommorow) {
        let now = dateTimeService.now();
        const from = unifyDate(addDate(now, 'day', 1), now);
        return {
            from: from,
            to: addDateSetTo6HoursMorning(from, 'day', 1),
            canUseLiveInPrematch: false
        };
    }
    if (params.filter == FilterType.nextWeek) {
        let now = dateTimeService.now();
        return {
            from: now,
            to: addDateSetTo6HoursMorning(now, 'day', 8),
            canUseLiveInPrematch: true
        };
    }
    if (params.filter == FilterType.byDay) {
        const dateParams = params.filterParams;
        if (isDateFilterParams(dateParams) && dateParams.date) {
            let now = dateTimeService.now();
            const from = unifyDate(dateParams.date, now);
            return {
                from,
                to: addDateSetTo6HoursMorning(from, 'day', 1),
                canUseLiveInPrematch: from <= now
            };
        }
    }
    if (params.filter == FilterType.byWeekDay) {
        const dateParams = params.filterParams;
        if (isDateFilterParams(dateParams) && dateParams.date) {
            let now = dateTimeService.now();
            const from = unifyDate(dateParams.date, now);
            return {
                from,
                to: addDateSetTo6HoursMorning(from, 'day', 1),
                canUseLiveInPrematch: from <= now
            };
        }
    }
    if (params.filter == FilterType.byTime) {
        const timeParams = params.filterParams;
        if (isTimeFilterParams(timeParams) && timeParams.hours) {
            let now = new Date();
            return {
                from: now,
                to: addDate(now, 'hour', timeParams.hours),
                canUseLiveInPrematch: true
            };
        }
    }
    if (params.filter === FilterType.timeDateFilter) {
        let now = new Date();
        switch (params.filterParams?.timeDateFilterValue) {
            case TimeDateFilterOptions.Plus1: return {
                from: now,
                to: addDate(now, 'hour', 1),
                canUseLiveInPrematch: true
            };
            case TimeDateFilterOptions.Plus3: return {
                from: now,
                to: addDate(now, 'hour', 3),
                canUseLiveInPrematch: true
            };
            case TimeDateFilterOptions.Plus6: return {
                from: now,
                to: addDate(now, 'hour', 6),
                canUseLiveInPrematch: true
            };
            case TimeDateFilterOptions.Today: return {
                from: now,
                to: addDateSetTo6HoursMorning(now, 'day', 1),
                canUseLiveInPrematch: true
            };
            case TimeDateFilterOptions.TodayTomorrow: return {
                from: now,
                to: addDateSetTo6HoursMorning(now, 'day', 2),
                canUseLiveInPrematch: true
            };
            case TimeDateFilterOptions.Weekend: return {
                from: getNextWeekendStartTime(now),
                to: getNextWeekendEndTime(now),
                canUseLiveInPrematch: false
            };
            case TimeDateFilterOptions.Tomorrow:
                const from = addDate(now, 'day', 1);
                from.setHours(0, 0, 0);
                return {
                    from: from,
                    to: addDateSetTo6HoursMorning(now, 'day', 2),
                    canUseLiveInPrematch: false
                };
            case TimeDateFilterOptions.Plus7d: return {
                from: now,
                to: addDateSetTo6HoursMorning(now, 'day', 8),
                canUseLiveInPrematch: true
            };
        }

    }
    return { canUseLiveInPrematch: true };
};

export const prepareRates = (params: IPushToEventListParams): { rateFrom?: number, rateTo?: number } => {
    const result: { rateFrom?: number, rateTo?: number } = {};
    if (!!params.rateFrom) {
        const value = Number(params.rateFrom);
        if (value >= RateFilterMinOddsRateInInput) {
            result.rateFrom = value;
        }
    }
    if (!!params.rateTo) {
        const value = Number(params.rateTo);
        if (value <= RateFilterMaxOddsRateInInput) {
            result.rateTo = value;
        }
    }
    return result;
}

export const pushToEventList = (params: IPushToEventListParams) => {
    let path = params.categoryKey ? paths().eventsList.replace(':categoryId?', `${params.categoryKey}`) : paths().eventsList.replace('/:categoryId?', ``);
    path = params.eventKey ? path.replace(':eventId?', `${params.eventKey}`) : path.replace('/:eventId?', ``);
    path = params.detailId ? path.replace(':detailId?', `${params.detailId}`) : path.replace('/:detailId?', ``);
    r.push(enrichPathOfOptionalMainMenuParams(path, params));
};

export function isByDateFilter(filter: FilterType) {
    return filter === FilterType.byDay || filter === FilterType.byWeekDay;
}

export function areFilterParamsEqual(params1: any, params2: any) {
    if (params1 === undefined && params2 === undefined) return true;
    if (params1 === params2) return true;
    if (isFilterValueParam(params1) && isFilterValueParam(params2)) return params1.timeDateFilterValue === params2.timeDateFilterValue;
    if (isTimeFilterParams(params1) && isTimeFilterParams(params2)) return params1.hours === params2.hours;
    if (isDateFilterParams(params1) && isDateFilterParams(params2)) return areDatesEqual(params1.date, params2.date);
    else return false;
}

export function isTimeFilterParams(arg: any): arg is ITimeFilterParams {
    return arg && arg.hours !== undefined;
}

export function isDateFilterParams(arg: any): arg is IDateFilterParams {
    return arg && arg.date !== undefined;
}

export function isFilterValueParam(arg: any) {
    return arg && arg.timeDateFilterValue !== undefined;
}

function addParams(path: string, params: string) {
    return params && params.length > 0 ? (path.indexOf('?') === -1 ? `${path}?${params}` : `${path}&${params}`) : path;
}

const unifyDate = (value: Date, now: Date): Date => {
    if (!isTheSameDay(value, now)) {
        value.setHours(0);
        value.setMinutes(0);
        value.setSeconds(0);
    }
    return value;
};

export const dateTime = {
    parse: (s: string): Date => {
        const d = s.split(' ');
        if (d.length !== 2) throw 'Invalid date time format.';
        const dateParts = d[0].split('-');
        if (dateParts.length !== 3) throw 'Invalid date format.';
        const timeParts = d[1].split(':');
        if (timeParts.length !== 3) throw 'Invalid time format.';
        return new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]), Number(timeParts[0]), Number(timeParts[1]), Number(timeParts[2]));
    },
    toString: (d: Date): string => {
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
    }
};
